import React, { useState } from 'react'
import { isEmpty } from 'lodash'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'
import { OptionsEditor } from '@/components/forms/OptionsEditor/OptionsEditor'

import { getOptionsError } from '../helpers'
import { isOptionGated } from '../helpers/fieldLinks.helpers'

// Edits a not-yet-saved pick_list/categorization field's staged options in the
// UI. Purely local: "Done" hands the edited list back for the form to hold
// until the whole flow is saved — it never persists a taxonomy on its own
// (unlike the PickList/Categorization modals, which save an existing taxonomy).
export const StagedOptionsModal = ({
  gatedOperands = [],
  show,
  onClose,
  fieldName,
  isCategorization,
  options,
  onSave,
}) => {
  const [draftOptions, setDraftOptions] = useState(options)

  const error = getOptionsError(draftOptions, isCategorization)
  const saveDisabled = !isEmpty(error)

  const handleSave = () => {
    if (saveDisabled) {
      return
    }
    onSave(
      draftOptions.map((option) => ({
        name: option.name.trim(),
        description: (option.description ?? '').trim(),
      }))
    )
    onClose()
  }

  return (
    <BasicModal
      show={show}
      onClose={onClose}
      title={`"${fieldName}" options`}
      size="tiny"
      scrolling
    >
      <div className="add-field">
        <OptionsEditor
          options={draftOptions}
          onChange={setDraftOptions}
          isOptionLocked={(option) => isOptionGated(option, gatedOperands)}
          isCategorization={isCategorization}
          testIdPrefix="staged-options"
        />
      </div>
      <div className="modal-footer">
        <Button type="button" onClick={onClose} data-testid="staged-options-cancel">
          Cancel
        </Button>
        <Button
          primary
          type="button"
          onClick={handleSave}
          disabled={saveDisabled}
          disabledTooltip={error}
          data-testid="staged-options-save"
        >
          Done
        </Button>
      </div>
    </BasicModal>
  )
}
